module.exports = __webpack_public_path__ + "img/itch_logo_41x35.cb797777.png";